import React, { useState, useEffect, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import NguonKhachHangApi from "service/nguonKhachHangApi";
import { TableDanhSach } from "./TableDanhSach";
import { pushNotification } from "utils/notifications";
import { ModalXoa } from "./ModalXoa";

export const ModalNguonKhachHang = ({
  show,
  onHide,
  dbName = null,
  onDataChanged,
}) => {
  const [listNguonKH, setListNguonKH] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tenMoi, setTenMoi] = useState("");
  const [showModalXoa, setShowModalXoa] = useState(false);
  const [modalXoaData, setModalXoaData] = useState(null);
  const [hideParent, setHideParent] = useState(false);
  const handleGetData = useCallback(() => {
    setIsLoading(true);
    NguonKhachHangApi.getList(dbName)
      .then((res) => {
        if (res.status === 200) {
          setListNguonKH(
            res.data.filter((item) => item.NguonKH_ID !== 0) || []
          );
        } else {
          setListNguonKH([]);
        }
      })
      .catch(() => {
        pushNotification("Lỗi khi tải danh sách nguồn khách hàng.", "error");
        setListNguonKH([]);
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    handleGetData();
    setHideParent(false);
  }, []);

  const handleThemMoi = useCallback(() => {
    if (!tenMoi || tenMoi.trim() === "") {
      pushNotification("Vui lòng nhập tên nguồn khách hàng.", "warning");
      return;
    }
    const data = { TenNguonKH: tenMoi.trim() };
    NguonKhachHangApi.create(data, dbName)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          pushNotification("Thêm mới thành công!", "success");
          setTenMoi("");
          handleGetData();
          if (onDataChanged) onDataChanged();
        } else {
          pushNotification(
            res.data?.Message || "Có lỗi xảy ra khi thêm mới.",
            "error"
          );
        }
      })
      .catch((err) =>
        pushNotification("Lỗi: " + (err.message || "Không xác định"), "error")
      );
  }, [tenMoi]);

  const handleKeyDownThemMoi = (e) => {
    if (e.key === "Enter") {
      handleThemMoi();
    }
  };
  const handleOpenModalXoa = (item) => {
    setModalXoaData(item);
    setHideParent(true);
    setShowModalXoa(true);
  };
  const handleCloseModalXoa = () => {
    setModalXoaData(null);
    setShowModalXoa(false);
    setHideParent(false);
  };
  const handleSavedModalXoa = () => {
    handleCloseModalXoa();
    handleGetData();
    if (onDataChanged) onDataChanged();
  };
  return (
    <>
      <Modal
        show={show && !hideParent}
        onHide={onHide}
        size="lg"
        centered
        backdrop="static"
        className="modal-new modal fade text-left"
        scrollable={true}
      >
        <div
          className="modal-content"
          style={{
            display: "flex",
            flexDirection: "column",
            maxHeight: "90vh",
          }}
        >
          <Modal.Header>
            <h4 className="modal-title color7-bold">
              <span className="btn-icon-right">
                <i
                  className="la la-users fs-2"
                  style={{ verticalAlign: "middle" }}
                ></i>
              </span>
              Nguồn khách hàng
            </h4>
            <button type="button" className="close-popup-new" onClick={onHide}>
              <img
                src="/app-assets/images/icon-dong-popup-v2.png"
                alt="close"
              />
            </button>
          </Modal.Header>

          <Modal.Body style={{ position: "relative", overflowY: "auto" }}>
            <div className="mb-3">
              <label className="form-label color7-bold">
                Tên nguồn khách hàng
              </label>
              <InputGroup>
                <Form.Control
                  value={tenMoi}
                  onChange={(e) => setTenMoi(e.target.value)}
                  onKeyDown={handleKeyDownThemMoi}
                  placeholder="Nhập tên nguồn khách hàng mới..."
                />
                <button
                  type="button"
                  className="btn-border-new ml-1"
                  onClick={handleThemMoi}
                >
                  <span>
                    <img
                      src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                      style={{ paddingBottom: "5px", marginRight: "6px" }}
                      alt="Thêm mới"
                    />
                    Thêm mới
                  </span>
                </button>
              </InputGroup>
            </div>
            <TableDanhSach
              isLoading={isLoading}
              listNguonKH={listNguonKH}
              dbName={dbName}
              onReload={handleGetData}
              onDataChanged={onDataChanged}
              onDelete={handleOpenModalXoa}
            />
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              className="btn btn-new-main btn-closenew"
              onClick={onHide}
            >
              <span>
                <i className="mdi mdi-close"></i>
              </span>
              &nbsp; Đóng
            </button>
          </Modal.Footer>
        </div>
      </Modal>
      {showModalXoa && (
        <ModalXoa
          show={showModalXoa}
          onHide={handleCloseModalXoa}
          onDeleted={handleSavedModalXoa}
          item={modalXoaData}
          dbName={dbName}
        />
      )}
    </>
  );
};
